import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as OfferMismatch } from '../../../../assets/Offers/offerMismatch.svg';
import {
    setAppliedOfferDetails,
    setOfferMisMatchModal,
    setSelectedActivePaymentTab
} from '../../../../slices/OfferSlice';
import {
    changeActivePaymentMethod,
    selectActivePaymentMethod
} from '../../../../slices/PaymentButtonSlice';
import { selectIsMobileLayout } from '../../../../slices/MobileLayoutSlice';
import './offerMisMatch.css';
import TranslateText from '../../../resuableComponents/TranslateText';
import { handlePrintCouponCondition } from '../../../../Utils/paymentUtils';
import { restorePaymentMethodsFromSession } from '../../../../slices/PaymentSessionDetailsSlice';
import { removeSelectedIntruments } from '../../../../slices/SavedInstrumentSlice';
import {
    continueWithoutOfferEnteredEvent,
    reenterDetailsOfferEnteredEvent,
} from '../../../../Utils/uiAnalytics';

const namesForModalPaymentMethodWise = {
    Upi: { name: 'Upi', id: 1 },
    Card: { name: 'Card', id: 2 },
    Wallet: { name: 'Wallet', id: 3 },
    NetBanking: { name: 'Bank', id: 4 },
    Emi: { name: 'Emi', id: 4 },
    BuyNowPayLater: { name: 'BNPL', id: 6 },
};

function OfferMisMatchModal({ showModal, setShowModal, baseColor }) {
    const [endText, setEndText] = useState('');
    const [isGatewayChangeRequired, setIsGatewayChangeRequired] = useState(false);
    const [availablePaymentMethod, setAvailablePaymentMethod] = useState('');
    const [isAllPaymentMethod, setIsAllPaymentMethod] = useState(false)

    const dispatch = useDispatch();
    const activePaymentMethod = useSelector(selectActivePaymentMethod);
    const appliedOfferDetail = useSelector(state => state.offers.appliedOfferDetail);
    const offerList = useSelector(state => state.offers.offerList);
    const isMobileLayout = useSelector(selectIsMobileLayout);
    const browserCountry = useSelector((state) => state.paymentSessionDetails.browserCountry);
    const totalPaymentSummaryValue = useSelector((state) => state.additionalComponents.totalPaymentSummaryValue);
    const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;



    const handleClearOffer = () => {
        continueWithoutOfferEnteredEvent();
        dispatch(setAppliedOfferDetails({}));
        dispatch(removeSelectedIntruments())
        dispatch(restorePaymentMethodsFromSession());

        dispatch(setOfferMisMatchModal(false));
    };
    const handleClick = () => {
        // Same button, whether it reads "Re-select Payment Method" or "Re-enter Details".
        reenterDetailsOfferEnteredEvent();
        if (isGatewayChangeRequired && availablePaymentMethod) {
            const currentMethod = namesForModalPaymentMethodWise[availablePaymentMethod];
            if (isMobileLayout) {
                dispatch(changeActivePaymentMethod(availablePaymentMethod));
            } else {
                dispatch(setSelectedActivePaymentTab(currentMethod?.id || 1));
            }
        } else {

        }
        setShowModal(false);
    };

    useEffect(() => {
        if (!activePaymentMethod || !appliedOfferDetail) return;

        const filteredOffers = offerList?.filter(offer =>
            appliedOfferDetail.codes?.includes(offer.code)
        );

        const availableTypes = filteredOffers.flatMap(offer =>
            offer.criteria?.applicableTo?.paymentMethods?.map(pm => pm.type).filter(Boolean) || []
        );

        const selectedPaymentMethod = availableTypes[0] || "Card";
        setAvailablePaymentMethod(selectedPaymentMethod);

        if (availableTypes.includes(activePaymentMethod)) {
            setEndText(` ${handlePrintCouponCondition(filteredOffers[0])}`);
            setIsAllPaymentMethod(false);
            setIsGatewayChangeRequired(false);
        } else {
            setIsAllPaymentMethod(true);
            setEndText('');
            setIsGatewayChangeRequired(true);
        }

    }, [activePaymentMethod, appliedOfferDetail, offerList]);

    const modalWidth = isMobileLayout ? '100%' : isGatewayChangeRequired ? '600px' : '550px';

    const modalStyle = isMobileLayout
        ? {
            bottom: 0,
            margin: 0,
            padding: 0,
            position: 'absolute',
            width: '100%',
            overflow: 'scroll',
            top: 'unset',
            maxWidth: 'unset',
            scrollbarWidth: 'none',
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
        }
        : { top: 200 };

    return (
        <Modal open={showModal} footer={null} closable={false} width={modalWidth} style={modalStyle}>
            <div className="misMatchModalContainer">
                <OfferMismatch />
                <p className="infoText" style={{ fontSize: isAllPaymentMethod ? "20px" : "16px" }}>
                    {isAllPaymentMethod ?
                        <TranslateText label={"OFFER_NOT_APPLICABLE_TEXT"}>
                            Selected Offer is not applicable with this payment method
                        </TranslateText>
                        : <>
                            <TranslateText label={"OFFER_APPLICABLE_ON_TEXT"}>
                                Selected Offer is  applicable on
                            </TranslateText>
                            <span>

                                {endText}
                            </span>
                        </>}
                </p>
                <div className="miss-match-button-container">
                    <button
                        className="re-enter-detail-btn"
                        onClick={handleClick}
                        style={{ background: baseColor }}
                    >
                        {isGatewayChangeRequired ?
                            <TranslateText label={"RESELECT_PAYMENT_GATEWAY"}> Re-select Payment Method </TranslateText>
                            : <TranslateText label={"REENTER_PAYMENT_DETAILS"}> Re-enter Details</TranslateText>
                        }
                    </button>
                    <button
                        onClick={handleClearOffer}
                        className="re-enter-detail-btn"
                        style={{ border: `1px solid ${baseColor}`, color: baseColor }}
                    >
                        <TranslateText label={"CONTINUE_WITHOUT_OFFER"}>
                            Continue without Offer
                        </TranslateText>
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default OfferMisMatchModal;
